import React from 'react';
import { observer } from 'mobx-react-lite';
import { Layout, Menu, MenuProps } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import featureStore from 'common/stores/features/feature.store';
const { Sider, Content } = Layout;

export const Reports = observer(({ baseRoute }: any) => {
  const navigate = useNavigate();
  const location = useLocation();

  const accountsSiderItems: MenuProps['items'] = [
    {
      label: 'Incident reports',
      key: `${baseRoute}/incident-reports`,
    },
  ];

  if (featureStore.isDailyActivityReportEnabled) {
    accountsSiderItems.push({
      label: 'Daily activity reports',
      key: `${baseRoute}/daily-activity-reports`,
    });
  }

  return (
    <Layout hasSider className="accounts-layout">
      <Sider className="sider-wrapper">
        <Menu
          defaultSelectedKeys={[location.pathname]}
          selectedKeys={[location.pathname]}
          items={accountsSiderItems}
          className="sider-tabs"
          onClick={(tab) => navigate(tab.key)}
        />
      </Sider>
      <Content className="content-style">
        <Outlet />
      </Content>
    </Layout>
  );
});
